// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"366":"43876b3c","594":"bac5e580","855":"59fe0926","863":"b8a47107","985":"2125c58f"}[chunkId] + ".css";
};